import { useState, useEffect, useCallback, useMemo } from "react";
import NotificationsGraphqlInstance from "@services/api/notification.graphql";

export const useNotifications = (enabled = true) => {
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      const res =
        await NotificationsGraphqlInstance.getPersonalNotificationsByUser();
      setNotifications(res || []);
      setIsLoading(false);
    })();
  }, [enabled]);

  const markAsRead = useCallback((id) => {
    setNotifications((prev) =>
      prev.map((item) => (item.id === id ? { ...item, read: true } : item)),
    );
    NotificationsGraphqlInstance.markPersonalNotificationAsRead(id);
  }, []);

  const unreadCount = useMemo(
    () => notifications.filter((item) => !item.read).length,
    [notifications],
  );

  return { notifications, unreadCount, isLoading, markAsRead };
};
